import { render, staticRenderFns } from "./Crime.vue?vue&type=template&id=41c53195&"
import script from "./Crime.vue?vue&type=script&lang=js&"
export * from "./Crime.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Crime.vue?vue&type=style&index=1&id=41c53195&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports